export default __webpack_public_path__ + "static/media/0176.19a01e81.jpg";